import { Button, EButtonColorVariant } from '@outdoorsyco/bonfire';
import React from 'react';
import { useIntl } from 'react-intl';

import MaxWidth from '@/components/common/layout/MaxWidth';

const renterBlock = [
  {
    title: 'Find the perfect RV',
    subtitle:
      'Search for RVs near you or your destination. Click on the listings for more information including host profiles, details on amenities, and photos. Save RVs that catch your eye for when you’ re ready to rent.',
  },
  {
    title: 'Book your RV',
    subtitle:
      'Found the one and ready to rent? Send the RV host a booking request. From that point, you can ask the host questions about the rig and arrange details like pick-up time.',
  },
  {
    title: 'Pick-up the RV or have it delivered',
    subtitle:
      'Outdoorsy hosts offer delivery to your home or campsite or you can arrange a pick-up. The host will do a key exchange to walk you through all the details of the RV.',
  },
  {
    title: 'Hit the road!',
    subtitle:
      'Enjoy the feeling of freedom and wellness that only time on the open road can bring. And rest assured knowing your trip is covered by our episodic insurance and you have 24/7 roadside assistance.',
  },
  {
    title: 'Return',
    subtitle:
      'After your great adventure, return the RV to the host in the same condition you received it.',
  },
];

const ownerBlock = [
  {
    title: 'Create your listing',
    subtitle:
      'Add photos of your RV.<br>Enter a name, description, and price<br>Confirm your location<br>Add photos and publish your listing<br>Simple as that. Now anyone looking in your area can find your RV and message you if they want to rent it.',
  },
  {
    title: 'Accept new bookings',
    subtitle:
      'Visit your dashboard to manage your listings, see messages, and keep track of all of your booking requests, present and past.',
  },
  {
    title: 'Handoff your key',
    subtitle:
      'Meet the renter, give them the rundown on your RV, and some tips for traveling in your area.',
  },
  {
    title: 'Earn cash',
    subtitle: 'Expect money in your bank account within 24 hours of a returned rental.',
  },
];

interface IProps {
  renter: boolean;
}

const HowToBlock: React.FC<IProps> = ({ renter }) => {
  const sections = renter ? renterBlock : ownerBlock;
  const intl = useIntl();
  const listYourRVTextButton = intl.formatMessage({ defaultMessage: 'List your RV', id: 'eRWzNe' });

  return (
    <MaxWidth>
      <ul
        className={`grid items-center justify-center grid-cols-1 gap-12 md:justify-start md:items-start md:grid-cols-2 lg:grid-cols-${sections.length}`}>
        {sections.map((section, index) => {
          return (
            <li
              key={index}
              className="flex flex-col items-center text-center lg:items-start lg:text-left">
              <div className="flex justify-center w-full mb-2 lg:justify-start">
                <div className="flex items-center justify-center w-10 h-10 text-xl bg-white border-2 border-gray-900 rounded-full">
                  {index + 1}
                </div>
              </div>
              <h3 className="mb-2 text-xl font-medium text-gray-900">{section.title}</h3>
              <p
                className="text-gray-900 text-md"
                dangerouslySetInnerHTML={{ __html: section.subtitle }}
              />
            </li>
          );
        })}
      </ul>
      {!renter && (
        <div className="mx-auto mt-4 mb-12">
          <Button
            href="/list-your-rv"
            variant={EButtonColorVariant.Primary}
            label={listYourRVTextButton}
          />
        </div>
      )}
    </MaxWidth>
  );
};

export default HowToBlock;
